// src/GlobalStyles.js
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.darkBlue};
    color: ${({ theme }) => theme.colors.white};
    margin: 0;
    padding: 0;
    font-family: font-family: ${({ theme }) => theme.fonts.primary};, sans-serif
    font-weight: "200";
  }
  .debug{
   border: 1px solid red;
  }

  @keyframes spin {
    to {
      transform: rotate(-360deg);
    }
  }
  .spin-animation {
    animation: spin 1s linear infinite;
    transition-duration: 700ms;
  }

  .wizardContainer {
    background-color: rgba(30, 65, 255, .25);
    border-radius: 60px;
    padding: 50px;
    color: white;
  }

  // Overriding the MUI styles 

  .MuiTypography-root {
    font-family: ${({ theme }) => theme.fonts.primary};
  }

  .MuiCheckbox-root{
    color: ${({ theme }) => theme.colors.white} !important
  } 

  .MuiSlider-colorSuccess{
    color: ${({ theme }) => theme.colors.green} !important;
  }
  
  .MuiSlider-thumbColorSuccess{
    color: ${({ theme }) => theme.colors.green} !important;
    opacity: 0.75;
  }

  .MuiSlider-colorWarning{
    color: ${({ theme }) => theme.colors.amber} !important;
  }
  
  .MuiSlider-thumbColorWarning{
    color: ${({ theme }) => theme.colors.amber} !important;
    opacity: 0.75;
  }

  input, textarea {
    color: ${({ theme }) => theme.colors.darkBlue}
  }

  .wizardInput label {
    color: white;
  }

  * {
    box-sizing: border-box;
  }

  /* Styles for ReactTagInput tags */
  .ReactTags__tag {
    background-color: ${({ theme }) =>
      theme.colors.blue}; /* Custom background color */
    color: white; /* Custom text color */
    padding: 5px 20px 5px 20px;
    border-radius: 25px;
    font-family: font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 600;
    margin: 5px;
    display: inline-block;
  }

  .ReactTags__remove {
    margin-left: 10px;
    margin-right: -6px;
    cursor: pointer;
    color: white;
    font-weight: bold;
  }

  .ReactTags__tagInput {
    border: none;
    // margin-top: 15px;
    margin-bottom: 15px;
    font-family: font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 300;
  }

  .ReactTags__tagInputField {
    border-radius: 5px;
    background-color: white;
    padding: 10px;
    font-family: font-family: ${({ theme }) => theme.fonts.primary};
    width: 100%;
  }

  .paypal-button-width{
    width: 90% !important;
  }

  .MuiFormControlLabel-label.Mui-disabled{
  color: ${({ theme }) => theme.colors.darkGray} !important;
  }
`;

export default GlobalStyles;
